import {
  require_util
} from "./chunk-3SPAAXKM.mjs";
import "./chunk-VW2P7MGW.mjs";
import "./chunk-PAN3FM5G.mjs";
import "./chunk-DFTHUOJ3.mjs";
import {
  __toESM
} from "./chunk-DELDZXUX.mjs";

// packages/common/node-std/src/util.js
var import_util = __toESM(require_util());
var import_util2 = __toESM(require_util());
var util_default = import_util.default;
var export_callbackify = import_util2.callbackify;
var export_inspect = import_util2.inspect;
var export_promisify = import_util2.promisify;
export {
  export_callbackify as callbackify,
  util_default as default,
  export_inspect as inspect,
  export_promisify as promisify
};
//# sourceMappingURL=util.mjs.map
